import { Link } from "react-router-dom";

import {
  useV1ReportingDefinitionsDestroy as useReportDefinitionDelete,
  useV1ReportingDefinitionsList as useReportDefinitionsList,
} from "@/api/generated/v1/v1";
import { PageBanner } from "@/shared/components/PageBanner";

export function ReportDefinitionListPage() {
  const { data, isLoading, isError } = useReportDefinitionsList();
  const deleteMutation = useReportDefinitionDelete();

  const definitions = Array.isArray(data) ? data : (data as any)?.results ?? (data as any)?.data ?? [];

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="گزارش‌ها"
        subtitle="مدیریت و مشاهده گزارش‌های سیستم"
        icon="📊"
        helpLink="/help/reporting/definitions"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          <Link
            to="/reporting/new"
            style={{
              padding: "0.6rem 1.25rem",
              borderRadius: "12px",
              background: "#ffffff",
              color: "#007270",
              fontWeight: 700,
              fontSize: "0.9rem",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "all 0.2s ease",
              textDecoration: "none"
            }}
          >
            <span>➕</span>
            <span>گزارش جدید</span>
          </Link>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>
        {isLoading && <p className="text-sm text-gray-500">در حال بارگذاری...</p>}
        {isError && <p className="text-sm text-red-600">خطا در دریافت گزارش‌ها.</p>}

        <div className="table-container" style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", textAlign: "right", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid var(--glass-border)" }}>
                <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>نام گزارش</th>
                <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>منبع داده</th>
                <th style={{ padding: "1rem", color: "var(--color-text-muted)" }}>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {!isLoading && definitions.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ padding: "2rem", textAlign: "center", color: "var(--color-text-muted)" }}>
                    هنوز گزارشی ساخته نشده است.
                  </td>
                </tr>
              )}
              {definitions.map((def: any) => (
                <tr key={def.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                  <td style={{ padding: "1rem", fontWeight: "bold" }}>
                    <Link to={`/reporting/${def.id}/run`} style={{ color: "inherit", textDecoration: "none" }}>
                      {def.name}
                    </Link>
                  </td>
                  <td style={{ padding: "1rem" }} dir="ltr" className="text-left font-mono text-sm">
                    {def.source_key}
                  </td>
                  <td style={{ padding: "1rem" }}>
                    <div className="flex gap-2">
                      <Link
                        to={`/reporting/${def.id}/edit`}
                        className="btn btn-secondary"
                        style={{ fontSize: "0.85rem", padding: "0.3rem 0.75rem", textDecoration: "none" }}
                      >
                        ویرایش
                      </Link>
                      <button
                        onClick={() => deleteMutation.mutate(def.id)}
                        className="btn btn-secondary"
                        style={{ fontSize: "0.85rem", padding: "0.3rem 0.75rem", background: "rgba(255,0,0,0.1)", color: "#ff4d4d", border: "1px solid rgba(255,0,0,0.2)" }}
                      >
                        حذف
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
